export default {"src":"/_next/static/media/facebook.82197087.svg","height":26,"width":25,"blurWidth":0,"blurHeight":0};